import { styled } from '@mui/material';

export const StyledTermsAndConditionsWrapper = styled('div')({
  marginTop: 54,
});
